import React, { useCallback, useState } from 'react'
import type { PropsWithChildren } from 'react'
import RedesignThemeWrapper from 'redesign/components/atoms/RedesignThemeWrapper'
import Toast from 'redesign/components/molecules/toast'
import ToastContext from './context'
import type { ToastPartialProps } from './types'

const ToastContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [toastProps, setToastProps] = useState<ToastPartialProps | undefined>()
  const [open, setOpen] = useState(false)

  const openToast = useCallback((props: ToastPartialProps) => {
    setToastProps(props)
    setOpen(true)
  }, [])
  const close = useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <ToastContext.Provider value={{ openToast }}>
      <RedesignThemeWrapper>{toastProps && <Toast {...toastProps} open={open} onClose={close} />}</RedesignThemeWrapper>
      {children}
    </ToastContext.Provider>
  )
}

export default ToastContextProvider
